import { useEffect, useState } from 'react';

/** Duree de l'animation de sortie d'un overlay (ms). Doit rester EGALE a
    --dur-base de tokens.css : l'element est demonte quand ce minuteur
    expire, juste apres la fin de taki-anim-fade-out / taki-anim-pop-out. */
export const OVERLAY_EXIT_MS = 200;

/**
 * Cycle de vie ANIME d'un overlay (modal, panneau lateral, menu) : quand
 * `open` passe a faux, l'element reste monte le temps de l'animation de
 * sortie (`closing` vrai), puis `mounted` tombe et l'appelant ne rend plus
 * rien. Sans cette phase, l'ouverture est douce mais la fermeture claque
 * (demontage instantane).
 *
 * C'est LA norme d'ouverture/fermeture des overlays MyTaki, le pendant JS
 * des utilitaires CSS taki-anim-* du socle :
 *
 *   const { mounted, closing } = useOverlayMotion(open);
 *   if (!mounted) return null;
 *   // voile   : closing ? 'taki-anim-fade-out' : 'taki-anim-fade'
 *   // panneau : closing ? 'taki-anim-pop-out'  : 'taki-anim-pop'
 *   // conteneur : + 'pointer-events-none' pendant closing (l'ecran
 *   //             redessous redevient cliquable sans attendre le fondu)
 *
 * Une app n'ecrit jamais ca elle-meme : elle passe par le Modal de @taki/ui,
 * qui embarque deja tout. Ce hook sert aux surfaces du socle (shell) et aux
 * futurs overlays standard.
 */
export function useOverlayMotion(open: boolean): { mounted: boolean; closing: boolean } {
  const [mounted, setMounted] = useState(open);
  useEffect(() => {
    if (open) {
      setMounted(true);
      return;
    }
    if (!mounted) return;
    const timer = window.setTimeout(() => setMounted(false), OVERLAY_EXIT_MS);
    return () => window.clearTimeout(timer);
  }, [open, mounted]);
  return { mounted, closing: mounted && !open };
}
